import React, { useState } from 'react';
import { Table } from 'reactstrap';
import { useQuery } from '@tanstack/react-query';
import PropTypes from 'prop-types';
import useAxios from '../../hooks/useAxios';
import FetchStatus from '../../components/fetchStatus/FetchStatus';
import MyBadge from '../../components/myBadge/MyBadge';
import DayView from '../../components/dayView/DayView';

const AttendanceApprovalTable = ({ id }) => {
  const [approvalMsg, setApprovalMsg] = useState('');
  const api = useAxios();

  const { isLoading, data } = useQuery({
    queryKey: ['attendance-approval'],
    queryFn: () =>
      api.get(`module/approval-request/attendance/${id}/logs`).then((res) => {
        setApprovalMsg(res.data.message);
        return res.data.data;
      }),
  });

  return (
    <div className="border border-1 rounded-4 pt-1 pb-2 overflow-hidden">
      {isLoading ? (
        <FetchStatus type="loading" />
      ) : data?.length > 0 ? (
        <Table hover responsive>
          <thead>
            <tr>
              <th style={{ minWidth: '50px' }}>#</th>
              <th style={{ minWidth: '200px' }}>PIC</th>
              <th style={{ minWidth: '100px' }}>Aksi</th>
              <th style={{ minWidth: '100px' }} colSpan="2">
                Status
              </th>
            </tr>
          </thead>
          <tbody>
            {data?.map((item) => (
              <tr key={item.id}>
                <td style={{ verticalAlign: 'middle' }}>{item.step_order}</td>
                <td style={{ verticalAlign: 'middle' }}>
                  <div className="d-flex flex-column gap-0">
                    {item.approver_name}
                    <small>{item.approver_position}</small>
                  </div>
                </td>
                <td style={{ verticalAlign: 'middle' }}>
                  <MyBadge color="purple">
                    {item.action_type === 'approve'
                      ? 'Menyetujui'
                      : item.action_type === 'verify'
                      ? 'Verifikasi'
                      : 'Mengetahui'}
                  </MyBadge>
                </td>
                <td style={{ verticalAlign: 'middle' }}>
                  {item.status === 'pending' && <MyBadge color="blue">Pending</MyBadge>}
                  {item.status === 'approved' && <MyBadge color="green">Approved</MyBadge>}
                  {item.status === 'verified' && <MyBadge color="green">Verified</MyBadge>}
                  {item.status === 'acknowledged' && <MyBadge color="green">Confirmed</MyBadge>}
                  {item.status === 'rejected' && <MyBadge color="red">Rejected</MyBadge>}
                  {item.status === null && <span>-</span>}
                </td>
                <td
                  style={{
                    verticalAlign: 'middle',
                    minWidth: item.action_at === null ? '0px' : '180px',
                  }}
                >
                  {item.action_at === null ? '' : <DayView date={item.action_at} time />}
                </td>
              </tr>
            ))}
          </tbody>
        </Table>
      ) : (
        <div className="text-center">
          <span className="text-center fw-bold">
            {approvalMsg === 'cancelled' && 'Request ini telah Anda batalkan'}
            {approvalMsg === 'ignored' && 'Request ini telah dibatalkan oleh Admin'}
          </span>
        </div>
      )}{' '}
    </div>
  );
};

AttendanceApprovalTable.propTypes = {
  id: PropTypes.number,
};

export default AttendanceApprovalTable;
